import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios'; // Use the base axios for login
import { jwtDecode } from "jwt-decode"; // Make sure it's imported

// 1. Create the context
const AdminAuthContext = createContext();

// 2. Create the provider component
export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('adminToken') || null);
  const [loading, setLoading] = useState(true);

  // Check if a token exists on initial load or when token changes
  useEffect(() => {
    if (token) {
      // --- ADDED THIS CHECK ---
      try {
        const decodedToken = jwtDecode(token); // Check the token itself
        if (decodedToken.exp * 1000 < Date.now()) {
          // Token is expired
          console.log("Admin token expired, logging out.");
          logout(); // Call logout to clear state (will set token to null)
        } else {
          // Token is valid, set admin data
          const adminData = localStorage.getItem('adminData');
          if (adminData) {
            setAdmin(JSON.parse(adminData));
          } else {
            // Token is valid but no admin data, something is wrong
            console.error("Admin token valid, but no admin data found in localStorage.");
            logout();
          }
        }
      } catch (error) {
        // Token is invalid
        console.error("Invalid admin token:", error);
        logout();
      }
      // --- END OF CHECK ---
    } else {
      // No token, ensure admin is null
      setAdmin(null);
    }
    setLoading(false);
  }, [token]); // Runs on load and whenever the token state changes

  // Login function
  const login = async (email, password) => {
    try {
      const res = await axios.post('/api/admin/login', { email, password });
      const { token, admin: adminData } = res.data;

      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminData', JSON.stringify(adminData));

      setToken(token); // This will trigger the useEffect to verify and set admin
      setAdmin(adminData); // Also set admin directly for immediate UI update
      
      return true; // Signal success
    } catch (error) {
      console.error('Admin login failed:', error);
      return false; // Signal failure
    }
  };

  // Logout function
  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    setToken(null);
    setAdmin(null);
  };

  return (
    <AdminAuthContext.Provider value={{ admin, token, login, logout, loading }}>
      {!loading && children}
    </AdminAuthContext.Provider>
  );
};

// 3. Create a custom hook for easy access
export const useAdminAuth = () => {
  return useContext(AdminAuthContext);
};
